import {useEffect, useState} from "react";
import SeoSchemaCreator from "./SeoOpenGraphCreator";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useParams} from "react-router-dom";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {css} from "@emotion/css";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export default function SeoComponent({blogID}) {



    const service = new MagazineService()

    useEffect(() => {
        if (typeof blogID !== 'undefined' && blogID >= 0) {
            loading.show()
            service.getSeo(blogID)
                .then(response => {
                    setMetaTitle(response.metaTile)
                    setMetaDescription(response.metaDescription)
                    setMetaRobots(response.metaRobots)
                    setMetaKeyboards(response.metaKeyboards)
                    setOpenGraph(response.openGraphItems)

                }).catch(reason => {

                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئيات سئو"))
            }).finally(_ => {

                loading.hide()
            })
        }
    }, [blogID])

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [metaRobots, setMetaRobots] = useState("");
    const [metaKeyboards, setMetaKeyboards] = useState("");
    const [openGraph, setOpenGraph] = useState([]);

    function handleUpdateInfo() {
        try {
            loading.show()
            service.updateSeo(
                blogID,
                metaTitle,
                metaDescription,
                metaRobots,
                metaKeyboards,
                openGraph
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی اطلاعات سئو سایت"))
            }).finally(_ => {
                loading.hide()
            })
        } catch (e) {
            showWarningMessage("خطا در بروزرسانی اطلاعات سئو")

            if (typeof service === 'undefined') {
                throw "Service not declared, please declare service and send it to component by props before use seo component ..."
            } else if (typeof service.updateSeo === 'undefined') {
                throw "Cant find updateSeo function in service, please declare it for update seo items ..."
            } else
                throw e
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"بهینه سازی موتور های جستجو"}
                subTitle={"متا ها ابزار هایی برای معرفی صحیح صفحات و محتواهای آن ها به موتور های جستجو هستند."}
                hasActionButton
                actionButtonOnclick={handleUpdateInfo}
            >
                <RaikoGridOneColumn className={css`padding-top: .5rem`}>
                    <RaikoSimpleInputOutlined
                        labelText={"Meta Title"}
                        setValue={setMetaTitle}
                        value={metaTitle}/>
                    <RaikoSimpleMultiLineInputOutlined
                        labelText={"Meta Description"}
                        setValue={setMetaDescription}
                        value={metaDescription}/>
                    <RaikoSimpleInputOutlined
                        labelText={"Meta Robots"}
                        setValue={setMetaRobots}
                        value={metaRobots}/>
                    <RaikoSimpleInputOutlined
                        labelText={"Meta Keyboard"}
                        setValue={setMetaKeyboards}
                        value={metaKeyboards}/>
                    <SeoSchemaCreator
                        schema={openGraph}
                        setSchema={setOpenGraph}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}
